import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function Categories() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
      <div className="text-center mb-10">
        <p className="text-xs uppercase tracking-widest text-[#C2410C] font-semibold">Browse</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#1F130B] mt-1">All Categories</h1>
        <p className="text-sm text-[#6B5B52] mt-2 max-w-lg mx-auto">Explore our full range of premium Kashmiri dry fruits, nuts, saffron and gift boxes.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {categories.map((c) => (
          <button
            key={c.slug}
            onClick={() => navigate(`/shop?category=${c.slug}`)}
            data-testid={`category-tile-${c.slug}`}
            className="group relative rounded-2xl overflow-hidden aspect-[4/5] border border-[#E7E0D6]"
          >
            <img src={c.image} alt={c.label} loading="lazy" className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C120C]/85 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
              <p className="font-display text-lg font-semibold text-white leading-tight">{c.label}</p>
              <p className="text-xs text-[#FDE68A] mt-0.5">Shop now →</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
